import googleAnalytics from '../assets/images/googleAnalytics.png';
import hubspot from '../assets/images/hubspot.png';
import cyderLogo from '../assets/images/icon.png';
import jira from '../assets/images/jira.png';
import mailchimp from '../assets/images/mailchimp.png';
import mixpanel from '../assets/images/mixpanel.png';
import monday from '../assets/images/monday.png';
import salesforce from '../assets/images/salesforce.jpg';
import segment from '../assets/images/segment.png';
import shopify from '../assets/images/shopify.png';
import slack from '../assets/images/slack.png';
import zapier from '../assets/images/zapier.png';
import zendesk from '../assets/images/zendesk.png';

import { classNames } from '../utils';
import { track } from '../utils/analytics';

const integrations = [
  {
    name: 'Zapier',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: zapier,
    link: 'https://docs.betterfunnel.ai/zapier',
  },
  {
    name: 'Custom Webhook',
    description: 'Get BetterFunnel leads & events to your backend.',
    icon: cyderLogo,
    link: 'https://docs.betterfunnel.ai/custom-webhook',
  },
  {
    name: 'Slack',
    description: 'Get messages and updates directly on slack.',
    icon: slack,
    comingSoon: true,
  },
  {
    name: 'Jira',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: jira,
    comingSoon: true,
  },
  {
    name: 'Hubspot',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: hubspot,
    comingSoon: true,
  },
  {
    name: 'Zendesk',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: zendesk,
    comingSoon: true,
  },
  {
    name: 'Monday.com',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: monday,
    comingSoon: true,
  },
  {
    name: 'Salesforce',
    description: 'Integrate BetterFunnel with your workflow.',
    icon: salesforce,
    comingSoon: true,
  },
  {
    name: 'Mixpanel',
    description: 'Get BetterFunnel analytics directly into Mixpanel',
    icon: mixpanel,
    comingSoon: true,
  },
  {
    name: 'Google Analytics',
    description: 'Get BetterFunnel analytics directly into Google Analytics',
    icon: googleAnalytics,
    comingSoon: true,
  },
  {
    name: 'Segment',
    description: 'Get BetterFunnel analytics directly into Segment',
    icon: segment,
    comingSoon: true,
  },
  {
    name: 'MailChimp',
    description: 'Run campaigns and get traffics using MailChimp',
    icon: mailchimp,
    comingSoon: true,
  },
  {
    name: 'Shopify',
    description: 'Fetch data durectly from your shopofy account',
    icon: shopify,
    comingSoon: true,
  },
];

export default function Integrations({ wide }: { wide?: boolean }) {
  return (
    <div className="p-0 sm:p-0">
      {/* <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Integrations
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            A list of all possible integrations.
          </p>
        </div>
      </div> */}
      <div
        className={classNames(
          'mt-0 grid grid-cols-1 gap-4',
          wide ? 'sm:grid-cols-2' : 'sm:grid-cols-1',
        )}
      >
        {integrations.map((integration) => (
          <div
            key={integration.name}
            className={classNames(
              integration.comingSoon
                ? 'pointer-events-none bg-gray-50'
                : 'bg-white',
              'relative flex items-center space-x-3 rounded-lg border border-gray-300 px-6 py-5 shadow-xs focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400',
            )}
            onClick={() => {
              track('add_integration_button_click', {
                integration: integration.name,
              });
              if (integration.link) {
                window.open(integration.link, '_blank');
              }
            }}
          >
            <div className="shrink-0">
              <img
                className="h-10 w-10 object-contain"
                src={integration.icon}
                alt=""
              />
            </div>
            <div className="min-w-0 flex-1">
              <a href="#" className="focus:outline-hidden">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-sm font-medium text-gray-900">
                  {integration.name}
                </p>
                <p className="truncate text-sm text-gray-500">
                  {integration.description}
                </p>
              </a>
            </div>
            {integration.comingSoon ? (
              <a className="text-gray-500">Coming soon</a>
            ) : (
              <a>Add</a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
